export default __webpack_public_path__ + "static/media/fraud.63998737.svg";